module.exports = __webpack_public_path__ + "static/car_icone5e4eb5bb2a568131182013e202f8df1.png";